import {JSX} from "react";

export default function Loader({small}: { small?: boolean }): JSX.Element {
	const klass = small ? "loader loader--small" : "loader";

	return (
		<span className={klass}>
            <span className="left"><span className="anim"></span></span>
            <span className="right"><span className="anim"></span></span>
        </span>
	);
}
